const STATUS_MAP = {
  live: ['live', 'inprogress', 'inplay', 'playing'],
  upcoming: ['upcoming', 'scheduled', 'notstarted', 'pregame', 'pre'],
  ended: ['ended', 'final', 'completed', 'complete', 'closed', 'resolved'],
  postponed: ['postponed', 'ppd', 'suspended', 'delayed', 'canceled', 'cancelled'],
};

const normalizeStatusValue = (value) =>
  (value || '')
    .toString()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');

const resolveStatusFromRaw = (rawStatus) => {
  if (!rawStatus) return null;
  const normalized = normalizeStatusValue(rawStatus);
  if (!normalized) return null;

  for (const [status, hints] of Object.entries(STATUS_MAP)) {
    if (hints.some((hint) => normalized.includes(hint))) {
      return status;
    }
  }

  return null;
};

const resolveStatusFromTime = (startTime) => {
  if (!startTime) return null;
  const now = new Date();
  const start = new Date(startTime);
  if (Number.isNaN(start.getTime())) return null;
  const diff = start - now;
  if (diff > 0) return 'upcoming';
  if (diff > -3 * 60 * 60 * 1000) return 'live';
  return 'ended';
};

export const getMarketStatus = (market) => {
  if (!market) return 'upcoming';

  const timeStatus = resolveStatusFromTime(market.startTime || market.start_time);
  const rawStatus =
    market.status ||
    market.eventStatus ||
    market.gameStatus ||
    market.matchStatus ||
    market.state ||
    market.event_state;

  const resolved = resolveStatusFromRaw(rawStatus);
  if (resolved === 'postponed') return 'upcoming';

  if (resolved === 'live' && timeStatus && timeStatus !== 'live') {
    return timeStatus;
  }

  const statusCandidate = resolved || timeStatus || 'upcoming';

  if (market.active === false || market.closed === true) {
    return 'ended';
  }

  if (
    statusCandidate === 'live' &&
    (market.acceptingOrders === false || market.accepting_orders === false)
  ) {
    return 'ended';
  }

  return statusCandidate;
};
